import type { FaireProductEntity } from "../../entity_types/product";

export const p_yp93d4m4ku: FaireProductEntity = {
  token: "p_yp93d4m4ku",
  type: "product",
  name: "Handwoven Patchwork Colorful Boho Palazzo Pants",
  brandToken: "b_7rkbvdp47b",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/f0dbc717389168a093e9c2b345da01df21c3a4db784675d7f0eb5a857ddf1dde.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/972b5ee559b0babe8db763a69bc1e93bd97722f3492ce3e7e1564411c8418dba.jpeg",
    "https://cdn.faire.com/fastly/5d3ec5d822e3534ec227f669e08542767521497223968d096bee7a94d89c27d7.jpeg",
    "https://cdn.faire.com/fastly/0ee8c3e5e4b6a0d9986ecee05ec68b7cf1ad7ee0280143bb758b720330cf8b54.jpeg",
    "https://cdn.faire.com/fastly/347d318d88d5eae235d563f9e2ccf501827fed3099c19f85f0eb1dfcef893dcd.jpeg",
    "https://cdn.faire.com/fastly/96fe963e1d6f0db308f0484e0241cb2dc2bcdeefcb26705f9f85ce93c0954fa3.jpeg",
    "https://cdn.faire.com/fastly/309d5d2ad990a669b0caf18c14690c86559e4b7c133a7711312a8a48ffcb343b.jpeg",
    "https://cdn.faire.com/fastly/c69075636787ceeee9894042dfe89eaa70abf0e4d968fd9874628ec88c708ee4.jpeg",
    "https://cdn.faire.com/fastly/b44241d8f17237bc444ab40ddf515f28b6829e386a4dad4296d90073cfa2f3a8.jpeg",
    "https://cdn.faire.com/fastly/a25b3a9f06b1475612e117f8b997698b04ef3ea8a4ef0b3f33a6584771c2dddc.jpeg",
    "https://cdn.faire.com/fastly/5ecd38e060e726fdde2f794e6e9df3d752f08289dccd267195030159a2cd1d06.jpeg",
    "https://cdn.faire.com/fastly/de79699c5584cc2de0bed4ceb9a1c9b7399605501d6bf5a7899986a6206116b0.jpeg",
    "https://cdn.faire.com/fastly/644b1a501bd0288063667d991b2aaa13bfa1f9144f67eaf462eddf27cdbbcd40.jpeg",
    "https://cdn.faire.com/fastly/ed7995f786d41e2a1d2e594112fba7495afe714d7cab54ff26a457b3b91c83e5.jpeg",
    "https://cdn.faire.com/fastly/8b363ae4394c2e1fa49b796c2655de4d83520a603db72abb0d31b6a73dd2aab1.jpeg",
    "https://cdn.faire.com/fastly/efc1ea66a28a42be1ef9f895a7a9df8ba6e2933910c70a08288c1213729d2ae5.jpeg",
    "https://cdn.faire.com/fastly/67d3fd6a2e448f82e0a3dc41bf5831458c9453352da2179f87505f3b650ba350.jpeg",
    "https://cdn.faire.com/fastly/6ad359712fec4956aef0865672e6437d9acaf1080dadae954f888712e8364d96.jpeg"
  ],
  priceDollars: 27.72,
  description: "Our stylish Patchwork Earth Tone Wide Leg Pants are the perfect choice for your closet! Handmade from patches of cotton and featuring a stylish palazzo cut, these pants combine hippie style, 90s fashion, and a touch of retro to create a unique look that can be worn year-round. Unisex and perfect for festivals and summer, these colorful and stylish pants are handmade with colorful, handwoven patches, bringing retro 90s style to modern all-season wear. Perfect for festivals and hippie vibes, look your best in these unique, stylish pants.\n\nHandmade in Nepal\n\nMaterial: Organic Cotton\n\nSize: One Size; Fits from US Size Small to XLarge\n\nElastic Waist\n\nTwo Side Pockets\n\nSINCE THESE PANTS ARE MADE OF DIFFERENT PATCHES, THE ONE YOU WILL RECEIVE WILL BE A LITTLE DIFFERENT IN COLOR THAN IN THE PICTURE.\n\n\n**FAIR TRADE\n**ETHICALLY SOURCED\n**SUSTAINABLE FASHION",
  tags: [],
  msrpDollars: 55.43,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:58.793Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
